import React from 'react';
import './ContactSection.css';

// Replace with your actual image import or URL
import contactImage from '../Assets/storyfest/flyer1.jpeg';
import logoImage from '../Assets/logos/storyfestlogo.png'; 

const ContactSection = () => {
  return (
    <section id="contact" className="storyfest-contact-section">
      
      {/* Background Subtle Pattern Overlay */}
      <div className="storyfest-contact-bg-pattern"></div>

      <div className="storyfest-container">
        
        {/* =========================================
            TOP SECTION: Text and Image
            ========================================= */}
        <div className="storyfest-contact-main-grid">
          
          {/* LEFT COLUMN: Typography & Contact Links */}
          <div className="storyfest-contact-content-left">
            <p className="storyfest-contact-label">02 / GET IN TOUCH</p>
            
            <h2 className="storyfest-contact-title">
              Let's make a<br />
              <span className="storyfest-text-gold-italic">story together.</span>
            </h2>
            
            <p className="storyfest-contact-description">
              For families, artists, vendors and partners: we'd love to 
              hear what you want to bring to StoryFest.
            </p>

            <div className="storyfest-contact-links">
              {/* Email Row */}
              <a href="mailto:office@amplehouse.net" className="storyfest-contact-row">
                <div className="storyfest-row-left">
                  <span className="storyfest-row-icon">✉️</span>
                  <div>
                    <p className="storyfest-row-label">EMAIL THE TEAM</p>
                    <p className="storyfest-row-value">office@amplehouse.net</p>
                  </div>
                </div>
                <span className="storyfest-row-arrow">↗</span>
              </a>

              {/* Phone Row */}
              <a href="tel:+233256687881" className="storyfest-contact-row">
                <div className="storyfest-row-left">
                  <span className="storyfest-row-icon">📞</span>
                  <div>
                    <p className="storyfest-row-label">CALL AMPLE HOUSE</p>
                    <p className="storyfest-row-value">+233 256 687 881</p>
                  </div>
                </div>
                <span className="storyfest-row-arrow">↗</span>
              </a>
            </div>
          </div>

          {/* RIGHT COLUMN: Framed Image */}
          <div className="storyfest-contact-image-wrapper">
            {/* Gold frame effect with corner stars */}
            <div className="storyfest-gold-frame">
              <span className="storyfest-star storyfest-top-left">✦</span>
              <span className="storyfest-star storyfest-top-right">✦</span>
              <span className="storyfest-star storyfest-bottom-left">✦</span>
              <span className="storyfest-star storyfest-bottom-right">✦</span>
              
              <img 
                src={contactImage} 
                alt="People connecting at StoryFest" 
                className="storyfest-contact-img" 
              />
            </div>
          </div>
        </div>

        {/* =========================================
            BOTTOM SECTION: Footer Bar
            ========================================= */}
        <div className="storyfest-contact-footer-bar">
          <div className="storyfest-footer-left">
            {/* Using an img tag for your actual logo */}
            <img src={logoImage} alt="StoryFest Logo" className="storyfest-footer-logo" />
          </div>
          
          <div className="storyfest-footer-center">
            <p>11–13 December 2026 · Accra City Hotel, Ghana</p>
          </div>
          
          <div className="storyfest-footer-right">
            <p>An Ample House production</p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ContactSection;